<template>
  <SfModalPortal
    modal-id="confirm-check-toggle-applicable-modal"
    size="xs"
    @opened="onOpen"
    @close="onClose"
  >
    <template #title>
      {{ I18n.t('components.check_link.confirm_not_applicable_modal.title') }}
    </template>

    <template #body>
      <div class="tw-p-4">
        <p class="tw-mb-4">
          {{
            I18n.t('components.check_link.confirm_not_applicable_modal.body_1')
          }}
        </p>
        <p class="tw-mb-0 tw-font-bold">
          {{
            I18n.t('components.check_link.confirm_not_applicable_modal.body_2')
          }}
        </p>
      </div>
    </template>

    <template #footer>
      <div class="tw-w-full">
        <div class="tw-flex tw-justify-center">
          <SfButton variant="default" @click="onCancel">
            {{ I18n.t('common.cancel') }}
          </SfButton>
          <SfButton variant="danger" class="tw-ml-2" @click="onConfirm">
            {{
              I18n.t(
                'components.check_link.confirm_not_applicable_modal.confirm'
              )
            }}
          </SfButton>
        </div>
      </div>
    </template>
  </SfModalPortal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { SfModalPortal } from '@app/shared/vue/components/sf-modal'
import SfButton from '@app/shared/vue/components/sf-button/sf-button.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import type { ToggleCheckApplicablePayload } from '@app/types'

const I18n = useI18n()

const emit = defineEmits(['confirm', 'cancel', 'close'])

const checkLinkId = ref<number | null>(null)
const ledgerCheckListId = ref<number | null>(null)

const onOpen = (params: ToggleCheckApplicablePayload) => {
  checkLinkId.value = params.checkLinkId
  ledgerCheckListId.value = params.ledgerCheckListId
}

const onConfirm = () => {
  const payload = {
    checkLinkId: checkLinkId.value,
    ledgerCheckListId: ledgerCheckListId.value,
  } as ToggleCheckApplicablePayload

  emit('confirm', payload)
  onClose()

  window.eventHub.$emit('confirm-check-toggle-applicable', payload)
}

const onCancel = () => {
  emit('cancel')
  onClose()
}

const onClose = () => {
  window.modalCitizen.closeModalPortal()
  checkLinkId.value = null
  ledgerCheckListId.value = null
  emit('close')
}
</script>
